module.exports = __webpack_public_path__ + "static/media/eyeopen.9735db3c.svg";